import React, { ReactElement } from 'react';
import Logo from './Logo';
import InfoArea from './InfoArea';

const DesktopNavBar: React.FC = (): ReactElement => (
  <div className="hidden justify-center w-full items-center p-4 box-border sm:flex bg-light z-10">
    <div className="justify-between w-full max-w-6xl items-center flex">
      <Logo />
      <InfoArea />
    </div>
  </div>
);

export default DesktopNavBar;
